const override = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      return {
        '& .MuiDataGrid-columnHeaderTitle': {
          fontWeight: 'bolder',
        },
      };
    },
  },
};

export default override;
